<template>
  <div style="width:100%">
    <ListReminders :showOn="'customers'"></ListReminders>
  </div>
</template>

<script>
import ListReminders from "@/components/reminders/ListReminders"
export default {
  name: "Customers",
  components: {
    ListReminders
  },
  data: () => ({
  }),
}
</script>

<style lang="scss" scoped>
</style>